module.exports = __webpack_public_path__ + "static/media/map-outline-01.0555e99c.svg";